import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

// TODO проверить необходимость существования - выпилить?
const query = gql`
query IntentsResolver($operatorId: Int!) {
  skills(operatorId: $operatorId) {
    id
    weight
    requestType {
      name
    }
  }
}`;

function getSkills(operatorId) {
  return apollo.client.query({
    variables: { operatorId },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.skills);
}

export default getSkills;
